export default __webpack_public_path__ + "static/media/640_dummy2016-fotograf02-mobile-de.15046cad.png";